import { tw } from "@careinfo/tailwind";
import Cleave from "cleave.js/react";
import APIS from "../../constant/Endpoint";
import CrossIcon from "../../Icons/CrossIcon";
import ItemsComboboxInput from "../Reusable/ItemsComboboxInput";
import NumberField from "../Reusable/NumberField";
import TextField from "../Reusable/TextField";

const ServiceForm = (props: any) => {
  const {
    fields,
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    isDraft,
    control,
    handleAddRow,
    remove,
  } = props;
  return (
    <>
      <div className={tw`flex gap-x-4 mt-2 w-full `}>
        <div
          className={tw`grid w-full gap-x-2`}
          style={{ gridTemplateColumns: "60px 120px 1fr" }}
        >
          <p className={tw`font-semibold`}>S.N</p>
          <p className={tw`font-semibold`}>HS Code</p>
          <p className={tw`font-semibold`}>Description</p>
        </div>
        <div className={tw`grid grid-cols-2 w-[65%] gap-x-4`}>
          <p className={tw`font-semibold`}>Amount</p>
          <p className={tw`font-semibold`}>Discount</p>
        </div>
      </div>
      <div id="sub-product">
        {fields.map((field: any, index: any) => {
          return (
            <div key={index}>
              <div className={tw`flex  mb-1  gap-x-6 w-full`}>
                <div
                  className={tw`w-full flex items-start justify-center space-x-1`}
                >
                  <input
                    disabled={true}
                    value={index + 1}
                    className={tw`bg-[#EEF5F4] p-2 w-14 h-9 mt-2`}
                    {...register(`items.${index}.serial_number`)}
                  />
                  <div className={tw`max-w-20`}>
                    <TextField
                      control={control}
                      name={`items.${index}.hs_code`}
                      placeholder="HS Code"
                      disabled={!isDraft}
                    />
                  </div>
                  <ItemsComboboxInput
                    url={APIS.PRODUCT}
                    queryKey={"inventory-info"}
                    register={register(`items.${index}.account`)}
                    errors={errors?.items?.[index]?.account}
                    name={`items.${index}.account`}
                    setValue={setValue}
                    taxable={`items.${index}.is_taxable`}
                    HsCode={`items.${index}.hs_code`}
                    props={{
                      is_active: true,
                    }}
                    value={getValues(`items.${index}.account`)}
                    placeholder={"Search Items"}
                    clearErrors={clearErrors}
                    disabled={!isDraft}
                  />
                </div>
                <div className={tw`flex w-[70%]  gap-x-2 `}>
                  <div className={tw`grid grid-cols-2 gap-x-4 w-full`}>
                    <NumberField
                      value={getValues(`items.${index}.amount`)}
                      register={register(`items.${index}.amount`)}
                      errors={errors?.items?.[index]?.amount}
                      // label={"Debit"}
                      setValue={setValue}
                      delimiter=","
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                    />
                    <NumberField
                      value={getValues(`items.${index}.discount`)}
                      register={register(`items.${index}.discount`)}
                      errors={errors?.items?.[index]?.discount}
                      // label={"Debit"}
                      setValue={setValue}
                      delimiter=","
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Tab" &&
                          index === fields.length - 1 &&
                          !e.shiftKey
                        ) {
                          e.preventDefault();
                          handleAddRow();
                          setTimeout(() => {
                            const newRowInput =
                              document.querySelector<HTMLInputElement>(
                                `input[name="items.${fields.length}.account"]`
                              );
                            newRowInput?.focus();
                          }, 0);
                        }
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    className={tw`rounded p-1 h-8 mt-2   border border-gray-400 text-xs`}
                    disabled={index === 0 || !isDraft}
                    onClick={() => remove(index)}
                  >
                    <CrossIcon />
                  </button>
                </div>
              </div>
              <hr />
            </div>
          );
        })}
        {errors?.items?.root?.message && (
          <span
            className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
          >
            <span className={tw`block`}>
              {errors.items.root.message as string}
            </span>
          </span>
        )}
        <div className={tw`w-full flex justify-start  mt-2`}>
          <button
            type="button"
            disabled={!isDraft}
            className={tw`rounded p-1 mb-1 border border-gray-400 text-xs`}
            onClick={() => handleAddRow()}
          >
            Add Row
          </button>
        </div>
        <div
          className={tw` w-[350px]  -mt-4  ml-auto flex items-center justify-between p-2 bg-[#EEF5F4] rounded-lg`}
        >
          <div className={tw`flex flex-col gap-y-2`}>
            <p>Items Value</p>
            <p>Total Discount</p>
            <p>Non Taxable Amount</p>
            <p>Taxable Amount</p>
            <div className={tw`flex items-center gap-x-2`}>
              <span>VAT</span>
              <Cleave
                type="text"
                className={tw`w-8 focus:outline-none bg-white px-1 text-center `}
                value={getValues("tax_rate")}
                autoComplete="off"
                disabled={!isDraft}
                onBlur={(e) => clearErrors("tax_rate")}
                onChange={(e) => setValue("tax_rate", e.target.value)}
                options={{
                  numeral: true,
                  numeralDecimalMark: ".",
                  numeralDecimalScale: 0,
                  numeralPositiveOnly: true,
                  delimiter: "",
                }}
              />
              %
            </div>
            <p className={tw`font-semibold`}>Total Amount</p>
          </div>
          <div className={tw`flex flex-col gap-y-2 text-right`}>
            <p>
              {Number(getValues("items_value")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("total_discount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("non_taxable_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("taxable_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("vat_tax_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p className={tw`font-semibold`}>
              {Number(getValues("total_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceForm;
